(function () {
  'use strict';
  function initialize() {
    var forms = document.querySelectorAll('.ws-product-form');
    var status = document.getElementById('interaction-status');
    var mobileQuantity = document.getElementById('mobile-quantity');
    var mainImage = document.getElementById('main-product-image');
    var caption = document.getElementById('gallery-caption');
    function updateOffer(selected, announce) {
      var variantId = selected.value;
      var label = selected.dataset.packLabel;
      forms.forEach(function (form) {
        form.querySelectorAll('input[type="radio"][name="id"]').forEach(function (input) {
          input.checked = input.value === variantId;
          var option = input.closest('.quantity-option');
          if (option) option.classList.toggle('selected', input.checked);
        });
      });
      document.querySelectorAll('[data-ws-total]').forEach(function (element) {
        try { element.textContent = new Intl.NumberFormat(element.dataset.locale || document.documentElement.lang, {style:'currency', currency:element.dataset.currency, currencyDisplay:'code'}).format(Number(selected.dataset.packPrice) / 100); } catch (_) {}
      });
      if (mobileQuantity && mobileQuantity.firstChild && mobileQuantity.firstChild.nodeType === 3) mobileQuantity.firstChild.nodeValue = label + ' · ';
      if (announce && status) status.textContent = status.dataset.quantityPrefix + label;
    }
    forms.forEach(function (form) {
      if (form.dataset.wsBound) return;
      form.dataset.wsBound = 'true';
      form.querySelectorAll('input[type="radio"][name="id"]').forEach(function (input) { input.addEventListener('change', function () { updateOffer(input, true); }); });
    });
    var initialOffer = document.querySelector('.ws-product-form input[type="radio"][name="id"]:checked');
    if (initialOffer) updateOffer(initialOffer, false);
    document.querySelectorAll('[data-ws-gallery]').forEach(function (button) {
      if (button.dataset.wsBound) return;
      button.dataset.wsBound = 'true';
      button.addEventListener('click', function () {
        if (!mainImage || !caption) return;
        mainImage.hidden = button.dataset.wsGallery === 'studio';
        var bottleCrop = document.querySelector('[data-original-bottle]');
        if (bottleCrop) bottleCrop.hidden = button.dataset.wsGallery !== 'studio';
        mainImage.src = button.dataset.imageUrl;
        mainImage.alt = button.dataset.imageAlt;
        mainImage.className = button.dataset.wsGallery === 'studio' ? 'studio-image' : 'original-image';
        var stage = mainImage.closest('.gallery-stage');
        if (stage) stage.classList.toggle('v4-studio-annotations', button.dataset.wsGallery === 'studio');
        caption.textContent = button.dataset.imageCaption;
        document.querySelectorAll('[data-ws-gallery]').forEach(function (item) { var active = item === button; item.classList.toggle('active', active); item.setAttribute('aria-pressed', String(active)); });
        if (status) status.textContent = status.dataset.galleryPrefix + button.dataset.imageCaption;
      });
    });
    var mobileOffer = document.querySelector('[data-mobile-offer]');
    if (mobileOffer && 'IntersectionObserver' in window) {
      if (window.windShieldBuyObserver) window.windShieldBuyObserver.disconnect();
      var visibleButtons = new Set();
      window.windShieldBuyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting && entry.intersectionRatio > 0.25) visibleButtons.add(entry.target); else visibleButtons.delete(entry.target); });
        mobileOffer.classList.toggle('is-hidden', visibleButtons.size > 0);
      }, {threshold:[0,0.25,0.5,1], rootMargin:'-100px 0px -20px 0px'});
      document.querySelectorAll('.ws-product-form .purchase-button').forEach(function (button) { window.windShieldBuyObserver.observe(button); });
    }
    var countryForm = document.getElementById('WindShieldCountryForm');
    if (countryForm && !countryForm.dataset.wsBound) {
      var select = countryForm.querySelector('[data-country-select]');
      if (select) { countryForm.dataset.wsBound = 'true'; countryForm.classList.add('is-enhanced'); select.addEventListener('change', function () { if (typeof countryForm.requestSubmit === 'function') countryForm.requestSubmit(); else countryForm.submit(); }); }
    }
    function openDeliveryAnswer() {
      var delivery = document.getElementById('delivery');
      if (delivery && delivery.tagName === 'DETAILS') delivery.open = true;
    }
    document.querySelectorAll('a[href$="#delivery"]').forEach(function (link) {
      if (link.dataset.wsBound) return;
      link.dataset.wsBound = 'true';
      link.addEventListener('click', openDeliveryAnswer);
    });
    if (window.location.hash === '#delivery') openDeliveryAnswer();
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();


(() => {
  const initReviewFilters = widget => {
    const fieldset = widget.querySelector('[data-review-filters]');
    const list = widget.querySelector('[data-review-items]');
    if (!fieldset || !list || fieldset.dataset.reviewBound === 'true') return;
    const records = Array.from(list.querySelectorAll('[data-review-record]'));
    if (!records.length) return;
    fieldset.dataset.reviewBound = 'true';
    fieldset.disabled = false;
    const rating = fieldset.querySelector('[data-review-rating-filter]');
    const sort = fieldset.querySelector('[data-review-sort]');
    const photo = fieldset.querySelector('[data-review-photo-filter]');
    const count = widget.querySelector('[data-review-visible-count]');
    const empty = widget.querySelector('[data-review-no-match]');
    const status = widget.querySelector('[data-review-status]');
    const apply = () => {
      const ordered = records.slice().sort((a, b) => {
        const scoreA = Number(a.dataset.rating) || 0;
        const scoreB = Number(b.dataset.rating) || 0;
        const dateA = Number(a.dataset.reviewDate) || 0;
        const dateB = Number(b.dataset.reviewDate) || 0;
        if (sort.value === 'highest') return scoreB - scoreA;
        if (sort.value === 'lowest') {
          if (!scoreA) return 1;
          if (!scoreB) return -1;
          return scoreA - scoreB;
        }
        return sort.value === 'oldest' ? dateA - dateB : dateB - dateA;
      });
      let shown = 0;
      ordered.forEach(record => {
        record.hidden = (rating.value !== 'all' && record.dataset.rating !== rating.value) || (photo.checked && record.dataset.hasPhoto !== 'true');
        if (!record.hidden) shown += 1;
        list.appendChild(record);
      });
      if (count) count.textContent = String(shown);
      if (empty) empty.hidden = shown > 0;
      if (status) status.textContent = (status.dataset.resultLabel || '') + shown;
    };
    fieldset.addEventListener('change', apply);
    apply();
  };
  const initReviews = () => {
    document.querySelectorAll('[data-ws-review-widget]').forEach(widget => {
      const panel = widget.querySelector('.v4-review-form-panel');
      const form = widget.querySelector('.v4-review-contact');
      if (!panel || !form || panel.dataset.reviewBound === 'true') return;
      initReviewFilters(widget);
      panel.dataset.reviewBound = 'true';
      const hashTargetsForm = window.location.hash === '#' + form.id || window.location.hash === '#write-review';
      panel.open = panel.dataset.feedbackState === 'true' || hashTargetsForm;
      const showPanel = focusField => {
        panel.open = true;
        form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        if (focusField) {
          const target = panel.querySelector('[data-feedback-message]') || panel.querySelector('[required]');
          if (target) target.focus({ preventScroll: true });
        }
      };
      [...widget.querySelectorAll('[data-ws-write-review]'), ...document.querySelectorAll('[data-ws-open-review]')].forEach(link => {
        if (link.dataset.reviewBound === 'true') return;
        link.dataset.reviewBound = 'true';
        link.addEventListener('click', event => {
          event.preventDefault();
          showPanel(true);
        });
      });
      if (panel.dataset.feedbackState === 'true') showPanel(true);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReviews);
  else initReviews();
  document.addEventListener('shopify:section:load', initReviews);
})();

(() => {
  const initializeVideos = () => {
    document.querySelectorAll('[data-ws-videos]').forEach(rail => {
      const track = rail.querySelector('[data-ws-video-track]');
      if (!track || rail.dataset.videoBound === 'true') return;
      rail.dataset.videoBound = 'true';
      const previous = rail.querySelector('[data-ws-video-prev]');
      const next = rail.querySelector('[data-ws-video-next]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = direction => {
        const card = track.querySelector('[data-ws-video-card]');
        const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 20;
        track.scrollBy({left: direction * ((card ? card.getBoundingClientRect().width : track.clientWidth) + gap), behavior: reduced.matches ? 'auto' : 'smooth'});
      };
      if (previous) previous.addEventListener('click', () => move(-1));
      if (next) next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      rail.querySelectorAll('video').forEach(video => video.addEventListener('play', () => {
        rail.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
      }));
      update();
    });
  };
  initializeVideos();
  document.addEventListener('shopify:section:load', initializeVideos);
})();

(() => {
  const initializeRegion = () => {
    const dialog = document.querySelector('[data-ws-region-dialog]');
    if (!dialog || dialog.dataset.bound) return;
    dialog.dataset.bound = 'true';
    const form = dialog.querySelector('form');
    const country = dialog.querySelector('[data-ws-dialog-country]');
    const currency = dialog.querySelector('[data-ws-currency]');
    const language = dialog.querySelector('[data-ws-dialog-language]');
    const suggestion = dialog.querySelector('[data-ws-country-suggestion]');
    const key = 'glassguardx-region-v10';
    let returning = false;
    let lastTrigger = null;
    let changed = false;
    try { returning = Boolean(localStorage.getItem(key)); } catch (_) {}
    const syncCurrency = () => { const option = country.selectedOptions[0]; if (option) currency.value = option.dataset.currency; };
    const saveChoice = () => { try { localStorage.setItem(key, JSON.stringify({country:country.value,language:language.value})); } catch (_) {} };
    document.querySelectorAll('[data-ws-region-open]').forEach(button => button.addEventListener('click', () => {
      lastTrigger = button;
      country.value = dialog.dataset.currentCountry;
      language.value = dialog.dataset.currentLanguage;
      syncCurrency();
      dialog.showModal();
    }));
    dialog.querySelector('[data-ws-region-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { saveChoice(); if (lastTrigger) lastTrigger.focus(); });
    country.addEventListener('change', () => {changed=true;syncCurrency();});
    language.addEventListener('change', () => {changed=true;});
    currency.addEventListener('change', () => {
      changed = true;
      const current = country.selectedOptions[0];
      if (current && current.dataset.currency === currency.value) return;
      const options = Array.from(country.options);
      const selected = options.find(option => option.value === dialog.dataset.currentCountry && option.dataset.currency === currency.value) || options.find(option => option.value === 'BG' && option.dataset.currency === currency.value) || options.find(option => option.dataset.currency === currency.value);
      if (selected) country.value = selected.value;
    });
    form.addEventListener('submit', saveChoice);
    if (!returning) {
      country.value = 'US';
      language.value = 'en';
      syncCurrency();
      dialog.showModal();
      fetch(dialog.dataset.discoveryRoot.replace(/\/$/, '') + '/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {credentials:'same-origin'}).then(response => response.ok ? response.json() : null).then(data => {
        const suggested = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        const fallback = data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts && data.suggestions[0].parts.country && data.suggestions[0].parts.country.handle;
        const code = String(suggested || fallback || '').toUpperCase();
        const option = Array.from(country.options).find(item => item.value === code);
        if (!option || changed) return;
        country.value = code;
        if (code === 'BG' && navigator.language.toLowerCase().startsWith('bg')) language.value = 'bg';
        syncCurrency();
        suggestion.textContent = (document.documentElement.lang === 'bg' ? 'Предложена държава: ' : 'Suggested country: ') + option.textContent;
        suggestion.hidden = false;
      }).catch(() => {});
    }
  };
  initializeRegion();
  document.addEventListener('shopify:section:load', initializeRegion);
})();

(() => {
  const initializeProductHelp = () => {
    document.querySelectorAll('[data-ws-image-dialog]').forEach(dialog => {
      if (dialog.dataset.imageBound) return;
      dialog.dataset.imageBound = 'true';
      const scope = dialog.closest('.shopify-section') || dialog.parentElement;
      const image = dialog.querySelector('[data-ws-image-detail]');
      const title = dialog.querySelector('[data-ws-image-title]');
      const steps = dialog.querySelector('[data-ws-image-steps]');
      let trigger = null;
      scope.querySelectorAll('[data-ws-image-open]').forEach(button => button.addEventListener('click', () => {
        trigger = button;
        const selected = scope.querySelector('[data-ws-gallery][aria-pressed="true"]');
        const instructions = button.hasAttribute('data-zoom-instructions') || (button.hasAttribute('data-zoom-active') && selected && selected.dataset.wsGallery === 'instructions');
        image.src = button.dataset.zoomUrl || (selected && selected.dataset.imageUrl) || image.src;
        image.alt = button.dataset.zoomAlt || (selected && selected.dataset.imageAlt) || image.alt;
        title.textContent = instructions ? dialog.dataset.instructionsTitle : dialog.dataset.productTitle;
        dialog.dataset.showSteps = String(instructions);
        steps.hidden = !instructions;
        dialog.showModal();
      }));
      dialog.querySelector('[data-ws-image-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { if (trigger) trigger.focus(); });
    });
    document.querySelectorAll('[data-ws-fit]').forEach(widget => {
      if (widget.dataset.fitBound) return;
      widget.dataset.fitBound = 'true';
      const tabs = Array.from(widget.querySelectorAll('[role="tab"]'));
      const panels = Array.from(widget.querySelectorAll('[role="tabpanel"]'));
      const select = tab => {
        tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
        panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          select(tabs[next]); tabs[next].focus();
        });
      });
    });
  };
  initializeProductHelp();
  document.addEventListener('shopify:section:load', initializeProductHelp);
})();
